import { Component } from '@angular/core';

@Component({
  selector: 'app-zodiac-card-details',
  templateUrl: './zodiac-card-details.component.html',
  styleUrls: ['./zodiac-card-details.component.scss']
})
export class ZodiacCardDetailsComponent {

}
